import { isSubTemplatedField } from '../../../types/templateModel'
import type { SpecialCaseComponentProps } from '../types'
import { useSpecialCasedSubTemplatedFieldVariant } from '../useSpecialCasedSubTemplatedFieldVariant'
import { CcCalcStepFieldValueMainContent } from './CcCalcStepFieldValueMainContent'
import { CcCalcStepFieldValuePosts } from './CcCalcStepFieldValuePosts'

export const CcCalcStepFieldValue = ({ data }: SpecialCaseComponentProps) => {
  const variant = useSpecialCasedSubTemplatedFieldVariant(data)
  const postField = variant?.fields.find((field) => field.name === 'post')
  const hasPosts = !!postField?.value

  return (
    <div className="flex size-full flex-row">
      <div className="flex w-full">
        <CcCalcStepFieldValueMainContent data={data} />
      </div>
      {hasPosts && postField && isSubTemplatedField(postField) && (
        <div className="mx-2 w-[20px]">
          <CcCalcStepFieldValuePosts field={postField} />
        </div>
      )}
    </div>
  )
}
